module.exports = __webpack_public_path__ + "static/img/dailyd.f8e70ef.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dailyd.png
// module id = dmgg
// module chunks = 1